import { applicantsInformationSchema } from "../../forms/privateAviation/user/formSchema";
import ApplicantsInformation from "../../forms/privateAviation/user/steps/ApplicantsInformation";
import EditSectionPage from "./EditSectionPage";

const ApplicantsEditPage = () => {
  return (
    <EditSectionPage
      title="Applicants Information"
      schema={applicantsInformationSchema}
      step={1}
    >
      <ApplicantsInformation />
    </EditSectionPage>
  );
};

export default ApplicantsEditPage;
